<template>
  <b-row>
    <b-col>
      <b-row class="dashboard-nav">
        <b-col>
          <b-link :to="{ name: 'DashboardOverview', params: { teamId }  }">Overview</b-link>
        </b-col>
        <b-col>
          <b-link :to="{ name: 'DashboardTeamPerformance', params: { teamId }  }">Team performance</b-link>
        </b-col>
        <b-col>
          <b-link :to="{ name: 'DashboardTeamInteraction', params: { teamId }  }">Team interaction</b-link>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'Header',

  props: {
    teamId: {
      type: Number
    }
  }
}
</script>
